import { type ReactNode, useEffect, useId } from 'react';

import { isRichTextValueConsideredEmpty } from '@uniformdev/richtext';

import { Accordion } from '@/libraries/design/components/accordion/src/accordion.tsx';
import { RichTextComponent } from '@/libraries/design/utils';

import { useAccordionsSection } from '../../accordions-section/src/accordions-section.tsx';

export interface UniformAccordionProps {
	header: string;
	anchorId?: string;
	textBody?: string;
	richText?: string;
	uniformRichText?: unknown;
	contentBody?: ReactNode;
}
const UniformAccordion = (props: UniformAccordionProps) => {
	const { header, anchorId, textBody, richText, contentBody } = props;
	const section = useAccordionsSection();
	const sectionItemId = useId();

	useEffect(() => {
		if (!section) {
			return;
		}
		section.register(sectionItemId);
		return () => section.unregister(sectionItemId);
	}, [section?.register, section?.unregister, sectionItemId]);

	return (
		<Accordion
			header={header}
			id={anchorId}
			isOpen={section ? (section.openItems[sectionItemId] ?? false) : undefined}
			onOpenChange={section ? (isOpen) => section.setOpen(sectionItemId, isOpen) : undefined}
			headingElement={section?.headingElement === 'h3' ? 'h4' : 'h3'}
			content={
				contentBody ??
				(richText ? (
					<RichTextComponent text={richText} />
				) : !isRichTextValueConsideredEmpty(props.uniformRichText) ? (
					<RichTextComponent uniformParameter="uniformRichText" />
				) : (
					textBody
				))
			}
		/>
	);
};

export default UniformAccordion;
